import React, {Component} from 'react';
import {observer, Provider, inject } from "mobx-react";
import commentsStore from "../../stores/commentsStore";
import Spying from "./Spying";
import spyingStore from "../../stores/spyingStore";


class SpyingWithStore extends Component {
  constructor(props) {
    super(props);
    this._commentsStore=new commentsStore({ comment_url_var: props.comment_url_var });
    this._spyingStore=new spyingStore();
    if(this.props.standalone) {
      this._commentsStore.standalone = true;
    }
    if(this.props.editor_css) {
      this._commentsStore.editor_css = this.props.editor_css;
    }
    if(this.props.lang) {
      this.props.translateStore.lang=this.props.lang;
    }
  }

  componentWillUnmount() {
    /*this._commentsStore.destruct();
    historyVars.appendVars({ comment:"" });*/
  }
  componentDidMount() {
    if(!this.props.meStore.me.inited) {
      if(this.props.translateStore.lang == "ru") {
        this.props.translateStore.fetchTranslate();
      }
      this.props.meStore.fetchMe();
    }
  }

  render() {
    if(!this.props.meStore.me.inited || !this.props.translateStore.translate.inited) {
      return null;
    }
    return (
      <div>
        <Provider commentsStore={this._commentsStore} spyingStore={this._spyingStore}>
          <div className="hpadd20">
            <Spying {...this.props} />
          </div>
        </Provider>
      </div>
    )
  }
}

export default inject("meStore","translateStore")(observer(SpyingWithStore));